import { createEvent } from '@pass-frontend/utility/event-bus';

/** Event raised when a session has been extended */
export const SESSION_EXPIRY_UPDATED = createEvent<{
  expiry: number;
  expiresAt: string;
}>('session/expiry/updated');

/** Event raised when a session is about to expire */
export const SESSION_EXPIRES_SOON = createEvent<{ remainingSeconds: number }>(
  'session/expiry/warn',
);

/** Event raised when we *estimate* a session is expired. Note - this is no guarantee, since the actual
 * authenticity of the session is not queryable without extending it.
 */
export const SESSION_EXPIRED = createEvent<void>('session/expiry/expired');
